<template>
  <div class="flex gap-[9px] items-center custom-checkbox">
    <label
      class="text-[12px] text-charcoal leading-[20px] tracking-[0.25px] cursor-pointer"
      @change="handleChange"
    >
      <input
        v-model="model"
        type="checkbox"
        class="shrink-0 border border-grey-pale rounded-none"
      />
      <span class="checkmark"></span>
      {{ text }}
    </label>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';

import _ from 'lodash';
const uuid = _.uniqueId('hs-checkbox-group-');

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  text: {
    type: String,
    default: '',
  },
});

watch(
  () => props.modelValue,
  (newVal) => {
    model.value = newVal;
  }
);
const model = ref(props.modelValue);
const handleChange = () => {
  emit('update:modelValue', model.value);
};
</script>
